import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

const initSentry = () => {
    Sentry.init({
        Vue,
        dsn: "https://66a6a0c866374ef3b51aaca2a7a03e82@sentry-us.didiglobal.com/33",
        integrations: [
          new Integrations.BrowserTracing({
            // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [window.location.origin],
          }),
        ],
        ignoreErrors: [
          "NavigationDuplicated"
        ],
        // eslint-disable-next-line no-undef
        release: OE_COMMIT_SHA,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

  export default initSentry